import { NgModule } from "@angular/core";
import { IonicPageModule } from "ionic-angular";
import { CampaignPosterPage } from "./campaign-poster";

@NgModule({
  declarations: [CampaignPosterPage],
  imports: [IonicPageModule.forChild(CampaignPosterPage)],
})
export class CampaignPosterPageModule {}



// WEBPACK FOOTER //
// ./src/pages/campaign-poster/campaign-poster.module.ts